var render = function (_h,_vm) {var _c=_vm._c;return _c('script',{attrs:{"type":"application/json+ld"},domProps:{"innerHTML":_vm._s(_vm.$options.getJsonLd(_vm.props))}})}
var staticRenderFns = []

export { render, staticRenderFns }